module.exports = "<impressum></impressum>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/app/impressum/impressum.component.html
// module id = ./src/components/app/impressum/impressum.component.html
// module chunks = main